import { LoaderService } from './../../../../../_services/loader.service';
import { CmsService } from './../../../../../_services/strapi.service';
import { IntegrationService } from './../../../../../_services/integration.service';
import { MerchantService } from './../../../../../_services/merchant.service';
import { Component, inject, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';
import { File, Sdk } from 'src/app/_models/strapi-file';

@Component({
    selector: 'app-sdk-in-app',
    templateUrl: './sdk-in-app.component.html',
    styleUrls: ['./sdk-in-app.component.scss'],
    standalone: false
})
export class SdkInAppComponent implements OnInit {
  private readonly merchantService: MerchantService = inject(MerchantService);
  private readonly cmsService: CmsService = inject(CmsService);
  private readonly loaderService: LoaderService = inject(LoaderService);
  private readonly integrationService: IntegrationService = inject(IntegrationService);

  currentMerchantId: string;
  activeIntegrations: any;
  downloadableSdk: Array<Sdk> = [];
  isAndroidActive: boolean = false;
  isIosActive: boolean = false;

  constructor() {
    this.currentMerchantId = this.merchantService.currentMerchant._id;
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.cmsService.getSdks().subscribe({
      next: (resp) => {
        this.loaderService.stopLoader();
        this.downloadableSdk = resp || [];

        const merchantSettings = this.merchantService.currentMerchant?.settings || {};
        this.isIosActive = Boolean(merchantSettings.isSDKIOSActive);
        this.isAndroidActive = Boolean(merchantSettings.isSDKANDROIDActive);
      },
      error: () => this.loaderService.stopLoader()
    });
  }

  isSdkVisible(sdk: Sdk): boolean {
    const sdkType = String(sdk?.sdk_type || '').toLowerCase();
    return (this.isIosActive && sdkType === 'ios') || (this.isAndroidActive && sdkType === 'android');
  }

  download(file: File) {
    if (file) {
      this.cmsService.downloadPrivateFile(file.url).subscribe(blob => saveAs(blob, file.name));
    }
  }

}
